export const DEFAULT_AVATAR_URL = '/avatars/default_avatar.png'
export const FLOWERS_QUEST_ITEM_ID = '019b92c7-4294-76c8-a323-a5640bdf6abc'
export const DOTS_QUEST_ITEM_ID = '019bfa6f-0cee-755c-a8c3-133ad2e18809'
export const TAPLAPSE_BOOSTER = '0197b174-2a82-7490-b1b6-1a6fe9960dbd'
export const CHANGES_QUEST_ITEM_ID = '019c750c-d2b0-795a-9313-392b46b1447a'
export const NOT_QUEST_KEY_ITEM_ID = '019cbec1-b405-7e6e-8650-bee28acb28e4'
export const VOLUME_QUEST_ITEM_ID = '019cbec1-83b3-723c-9b7f-3af1cdcd6066'
export const BOX_QUEST_KEY_ITEM_ID = '019c9922-24fb-70d1-b524-65d83feb7c6a'
export const PANELKA_HINT_KEY_ITEM_ID = '019bb689-7155-7262-9bd5-d0015c0455db'
export const CURVE_QUEST_ITEM_ID = '019d2e24-3075-7d58-b94b-336b194a1a00'
export const PENCIL_ITEM_ID = '019d0a93-fae4-71ba-a0db-e77a3440173e'
export const CASSETE_ITEM_ID = '019d91d3-57d7-7a13-af0e-69460ea2ade9'
export const OLD_PHOTO_ITEM_ID = '019e1324-3567-7ff0-9279-8b0276a96781'

export const RING_FRAGMENT_HARLAN = '019b3ff1-3f5e-7e2d-a49f-3b89058c3736'
export const RING_FRAGMENT_KSARAT = '019bb668-a0aa-7001-b108-159cbc516bf6'
export const RING_FRAGMENT_ASTERION = '019bc144-cfb4-7fbb-876c-2bd6df475c61'
export const RING_FRAGMENT_VIRA = '019c0e42-0221-73b7-a53f-a53071b89ef6'
export const RING_FRAGMENT_RUVIY = '019c320a-882d-722d-8103-5dabc36b28d2'
export const RING_FRAGMENT_MORIAN = '019c750c-b946-7bea-b265-9b373486dd81'
export const RING_FRAGMENT_AILIN = '019c9922-40ff-7880-aab2-3c11a72bd934'
export const RING_FRAGMENT_SAFARIS = '019d0aa1-42c9-7db6-95a5-942dfdac99a5'

export const RING_FRAGMENT_IDS = [
  RING_FRAGMENT_HARLAN,
  RING_FRAGMENT_KSARAT,
  RING_FRAGMENT_ASTERION,
  RING_FRAGMENT_VIRA,
  RING_FRAGMENT_RUVIY,
  RING_FRAGMENT_MORIAN,
  RING_FRAGMENT_AILIN,
  RING_FRAGMENT_SAFARIS,
] as const

export const LAST_SPIRAL_BORDER_DEF_IDS = ['019e1be6-78a6-7742-bec5-cba3652dcb99', '019e1cd5-fdd2-7c24-8ebd-c17c7e6665aa']
